import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import PropTypes from 'prop-types'
import React, { memo } from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'
import MobileIconUi from '../styles/ui/MobileIconUi'

function MarginsStyle({
  marginTop = 0,
  marginRight = 0,
  marginBottom = 0,
  marginLeft = 0,
  mobileMarginTop = 0,
  mobileMarginRight = 0,
  mobileMarginBottom = 0,
  mobileMarginLeft = 0,
  update,
  mobileUpdate,
}) {
  const { isMobile } = useDeviceModeContext()

  const updateProp = style => value =>
    isMobile ? mobileUpdate(style, 'px')(value) : update(style, 'px')(value)

  return (
    <React.Fragment>
      <GroupTitle>settings_styles.margin.label</GroupTitle>
      <RangeElement
        label="settings_styles.margin.top"
        labelIcon={isMobile && <MobileIconUi />}
        value={Number.parseInt(isMobile ? mobileMarginTop : marginTop, 0)}
        onChange={updateProp('marginTop')}
        min={0}
        max={200}
      />
      <RangeElement
        label="settings_styles.margin.bottom"
        labelIcon={isMobile && <MobileIconUi />}
        value={Number.parseInt(isMobile ? mobileMarginBottom : marginBottom, 0)}
        onChange={updateProp('marginBottom')}
        min={0}
        max={200}
      />
      <RangeElement
        label="settings_styles.margin.left"
        labelIcon={isMobile && <MobileIconUi />}
        value={Number.parseInt(isMobile ? mobileMarginLeft : marginLeft, 0)}
        onChange={updateProp('marginLeft')}
        min={0}
        max={200}
      />
      <RangeElement
        label="settings_styles.margin.right"
        labelIcon={isMobile && <MobileIconUi />}
        value={Number.parseInt(isMobile ? mobileMarginRight : marginRight, 0)}
        onChange={updateProp('marginRight')}
        min={0}
        max={200}
      />
    </React.Fragment>
  )
}

MarginsStyle.propTypes = {
  marginTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mobileMarginTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mobileMarginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mobileMarginLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mobileMarginRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  update: PropTypes.func.isRequired,
  mobileUpdate: PropTypes.func.isRequired,
}

export default memo(MarginsStyle)
